import { MapPin } from "lucide-react";

/**
 * A place, as a link to the map.
 *
 * This used to read "Open in Google Maps" everywhere, which names the tool
 * rather than the thing. Apps that do this well link the **address itself**, so
 * the line you were already reading is the thing you tap, and nobody has to be
 * told which map app is involved. Where there is no address to show, the label
 * falls back to a plain "Location".
 *
 * The href is always a Google Maps universal URL (`maps.ts`): on a phone it
 * opens the Google Maps app, on a desktop the web map, with no API key and no
 * platform sniffing.
 */
export function MapLink({
  href,
  children,
  className,
}: {
  href: string;
  /** The address to show. Omit for a bare "Location" link. */
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={`inline-flex items-start gap-1.5 font-medium text-accent hover:underline ${className ?? ""}`}
    >
      <MapPin className="mt-0.5 size-3.5 shrink-0" aria-hidden strokeWidth={1.8} />
      <span>{children ?? "Location"}</span>
    </a>
  );
}
